<div class="button-container">
  <button class="dialog-button" [disabled]="!canEditSelected()"  (click)="edit(undefined)" type="button" mat-flat-button color="primary" >Edit</button>
  <button class="dialog-button" [disabled]="!canMergeSelected()" type="button" (click)="merge()" mat-flat-button color="primary" >Merge</button>
</div>
<div class="appointment-list" *ngIf="!hasAppointmentsToShow()">
  <div class="empty-state-msg">There are no appointments for this family.</div>
</div>

<div class="appointment-list" *ngIf="hasAppointmentsToShow()">

  <table mat-table [dataSource]="appointmentRows" class="smaller-table-size"  matSort (matSortChange)="changeSort($event)">

    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th mat-header-cell class="smaller-table-size" *matHeaderCellDef>Select</th>
      <td mat-cell class="smaller-table-size" *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="onAppointmentSelected($event, row)"
                      >
        </mat-checkbox>
      </td>
    </ng-container>
  
    <ng-container matColumnDef="isLate">
      <th mat-header-cell class="smaller-table-size" *matHeaderCellDef mat-sort-header> Is Late? </th>
      <td mat-cell class="smaller-table-size"  (click)="edit(element)" *matCellDef="let element"><span *ngIf="isAppointmentLate(element)" class="late-style"><mat-icon>notification_important</mat-icon></span></td>
    </ng-container>
    <ng-container matColumnDef="startDateTime">
      <th mat-header-cell class="smaller-table-size" *matHeaderCellDef mat-sort-header> Time </th>
      <td mat-cell class="smaller-table-size"  (click)="edit(element)"  *matCellDef="let element"> {{element.startDateTime | date:'short'}} </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell class="smaller-table-size" *matHeaderCellDef mat-sort-header> Status </th>
      <td mat-cell class="smaller-table-size"   (click)="edit(element)" *matCellDef="let element"> {{element.status}} </td>
    </ng-container>
    <ng-container matColumnDef="sequenceNum">
      <th mat-header-cell class="smaller-table-size" *matHeaderCellDef mat-sort-header> Sequence </th>
      <td mat-cell class="smaller-table-size"   (click)="edit(element)" *matCellDef="let element"> {{element.sequenceNum}} </td>
    </ng-container>
    <ng-container matColumnDef="expectedDateTime">
      <th mat-header-cell class="smaller-table-size" *matHeaderCellDef mat-sort-header> Expected </th>
      <td mat-cell class="smaller-table-size"   (click)="edit(element)" *matCellDef="let element"> <span *ngIf="element.expectedDateTime">{{element.expectedDateTime | date:'short'}}</span></td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell class="smaller-table-size" *matHeaderCellDef mat-sort-header> Description </th>
      <td mat-cell class="smaller-table-size"  (click)="edit(element)" *matCellDef="let element"> {{element.description}} </td>
    </ng-container>
    <ng-container matColumnDef="teamMemberName">
      <th mat-header-cell class="smaller-table-size" *matHeaderCellDef mat-sort-header> Team Member </th>
      <td mat-cell class="smaller-table-size"  (click)="edit(element)" *matCellDef="let element"> {{element.teamMemberName}} </td>
    </ng-container>
    <ng-container matColumnDef="checklistName">
      <th mat-header-cell class="smaller-table-size" *matHeaderCellDef mat-sort-header> Checklist </th>
      <td mat-cell class="smaller-table-size"   (click)="edit(element)" *matCellDef="let element"> {{element.checklistName}} </td>
    </ng-container>
    <ng-container matColumnDef="requiredItems">
      <th mat-header-cell class="smaller-table-size" *matHeaderCellDef mat-sort-header> Required Items </th>
      <td mat-cell class="smaller-table-size"   (click)="edit(element)" *matCellDef="let element"> {{element.requiredItems}} </td>
    </ng-container>
    <ng-container matColumnDef="memberCompletionScore">
      <th mat-header-cell class="smaller-table-size" *matHeaderCellDef mat-sort-header> Completion Score </th>
      <td mat-cell class="smaller-table-size"   (click)="edit(element)" *matCellDef="let element"> {{element.memberCompletionScore}} </td>
    </ng-container>
    <ng-container matColumnDef="coordinatorCompletionScore">
      <th mat-header-cell class="smaller-table-size" *matHeaderCellDef mat-sort-header> Coordinator Score </th>
      <td mat-cell class="smaller-table-size"   (click)="edit(element)" *matCellDef="let element"> {{element.coordinatorCompletionScore}} </td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayColumns;"
       >
    </tr>
  </table>
</div>
<div class="add-new-container">
  <button mat-fab color="primary" (click)="edit(null)">
 + Add new
  </button>
</div>